import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import rte, { command } from '../rte.js'
import input from "@mailobj-browser/front/js/events/types/input.js"
import one from "@mailobj-browser/front/js/selectors/one.js"
import closest from "@mailobj-browser/front/js/selectors/closest.js"
import all from "@mailobj-browser/front/js/selectors/all.js"
import selectInput from "./selectInput/selectInput.js"
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onInput = object(listener, {
	type: input,
	passive,
	task: (
		select
	) => {
		const { value } = select
		const form = closest('form', select)
		const id = one('iframe[data-rte]', form)?.id
		
		if (id) {
			command(id, 'fontname', value)
		}
	}
})

const find = (
	select,
	family
) => {
	const template = one('template', select)
	const { content } = template
	const inputs = all('input', content)
	const name = family.split(',').at(0).trim()
	
	for (const input of inputs) {
		const { value } = input
		
		if (value.replace(/\s*,\s*/g, ',').split(',').includes(name)) {
			return object(null, {
				input,
				template
			})
		}
	}
}

const family = (
	text = null,
	body = null
) => {
	if (text) {
		const font = closest('font[face]', text)
		
		if (font) {
			return font.face ?? ''
		}
	}
	
	const { dataset } = body
	const { fontFamily } = dataset
	
	return fontFamily
}

export const highlight = (
	select,
	modifier,
	text = null,
	body = null
) => {
	const match = find(select, family(text, body))
	
	if (!match) {
		return
	}
	
	const { input, template } = match
	
	selectInput(select, template, input)
	select.classList.add(modifier)
}

export default select => {
	const { style, value } = select

	style.fontFamily = value
	onInput.listen(select)
	rte(select, object(null, { highlight }))
}
